import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, header, nameCircles } from '../../../../styles/colors';
import { truncateTextStyle } from '../../../../styles/styles';

const borderStyle = `1px solid ${borderColor}`;

export const styleSheet = StyleSheet.create({
	automationCol: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		justifyContent: 'space-between',
		flex: 1,
		minWidth: 100,
	},
	automationColButtonWrapper: {
		display: 'flex',
		flex: 0.34,
		justifyContent: 'center',
	},
	automationColLinkWrapper: {
		'@media only screen and (max-width: 1280px)': {
			flexDirection: 'column',
		},
		display: 'flex',
		flex: 0.66,
		justifyContent: 'space-around',
	},
	automationName: {
		color: '#4a4a4a',
	},
	automationSteps: {
		color: header,
		fontSize: 11,
		marginTop: 6,
	},
	button: {
		':last-child': {
			marginLeft: 16,
		},
		fontSize: 14,
		margin: 0,
		padding: 4,
		textAlign: 'center',
	},
	cancelAutomationCTA: {
		'@media only screen and (min-width: 1580px)': {
			maxWidth: 140,
		},
		maxWidth: 80,
	},
	checkboxCol: {
		alignItems: 'center',
		display: 'flex',
		width: 30,
	},
	contacts: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		flex: 1,
		minWidth: 100,
	},
	copyIdIcon: {
		':hover': {
			cursor: 'pointer',
		},
	},
	linkIcon: {
		padding: '5px 0 0 5px',
	},
	manageAutomationCTA: {
		maxWidth: 100,
	},
	nameTags: {
		margin: 4,
		maxWidth: '80%',
	},
	nameTagsColumn: {
		alignItems: 'center',
		display: 'inline-flex',
		flexWrap: 'wrap',
		flex: 1,
		minWidth: 100,
	},
	row: {
		borderTop: borderStyle,
		cursor: 'pointer',
		display: 'flex',
		minHeight: 100,
		padding: 16,
	},
	rowLast: {
		borderTop: borderStyle,
		borderBottom: borderStyle,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		cursor: 'pointer',
		display: 'flex',
		minHeight: 100,
		paddingBottom: 16,
		paddingTop: 16,
		paddingLeft: 16,
		paddingRight: 16,
		boxSizing: 'border-box',
	},
	status: {
		marginTop: 6,
	},
	subject: {
		alignItems: 'center',
		color: brandPrimary,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		fontWeight: 600,
		lineHeight: '18px',
		...truncateTextStyle,
	},
	subjectCell: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginBottom: 6,
		flex: 1,
		minWidth: 100,
		lineHeight: '1.2em',
	},
	tags: {
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		flex: 1,
		minWidth: 100,
	},
	unClickableSubject: {
		':hover': {
			color: brandPrimary,
			cursor: 'default',
			textDecoration: 'none',
		},
	},
	userChipIcon: {
		background: nameCircles,
		borderRadius: 10,
		boxSizing: 'border-box',
		height: 18,
		padding: 2,
		width: 18,
	},
});
